export default "__VITE_ASSET__Dy99teWw__"